// extracted by mini-css-extract-plugin
export default {"tokens":"\"../../styles/tokens.css\"","gray":"#979797","timestamp":"styles_timestamp__zB5x4","small":"styles_small__9BXUD"};